import React, { useState, useEffect } from 'react';
import {
  optOutAnalytics,
  optInAnalytics,
  hasAnalyticsConsent,
  onConsentChange,
} from '../analytics';
import './PrivacyModal.css';

export default function PrivacyModal({ onClose }) {
  const [analyticsOn, setAnalyticsOn] = useState(hasAnalyticsConsent());

  useEffect(() => {
    return onConsentChange((choice) => {
      setAnalyticsOn(choice === 'granted');
    });
  }, []);

  const handleToggle = () => {
    if (analyticsOn) {
      optOutAnalytics();
      return;
    }
    optInAnalytics();
  };

  return (
    <div
      className="privacy-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Privacy policy"
      data-analytics-ignore="true"
      onClick={onClose}
    >
      <div className="privacy-modal" onClick={(e) => e.stopPropagation()}>
        <h2 className="privacy-modal__title">Privacy</h2>
        <p className={`privacy-modal__status ${analyticsOn ? 'is-on' : 'is-off'}`}>
          {analyticsOn
            ? 'Analytics is currently on.'
            : 'Analytics is currently off. No GA cookies or tracking requests are sent.'}
        </p>
        <p>
          This portfolio uses Google Analytics 4 to understand how visitors use the site.
          Analytics runs by default unless you opt out. We do not use advertising cookies.
        </p>
        <p className="privacy-modal__label">What we may collect when analytics is on</p>
        <ul>
          <li>Pages and sections viewed, scroll depth, and time on the site</li>
          <li>Navigation, link clicks, and project interactions</li>
          <li>Basic performance metrics (e.g. page load quality)</li>
          <li>Browser and device information sent automatically by GA4</li>
        </ul>
        <p className="privacy-modal__label">Third parties</p>
        <ul>
          <li>Google Analytics 4 (analytics)</li>
          <li>Font Awesome (contact icons)</li>
        </ul>
        <p>
          Your choice is stored in this browser for up to 12 months. The site works fully
          either way.
        </p>
        <div className="privacy-modal__actions">
          <button type="button" className="privacy-modal__button privacy-modal__button--primary" onClick={onClose}>
            Close
          </button>
          <button
            type="button"
            className={`privacy-modal__button ${analyticsOn ? '' : 'privacy-modal__button--primary'}`}
            onClick={handleToggle}
          >
            {analyticsOn ? 'Opt out of analytics' : 'Turn analytics back on'}
          </button>
        </div>
      </div>
    </div>
  );
}
